import { render, staticRenderFns } from "./TrusteeInformation.vue?vue&type=template&id=645bdeb5&"
import script from "./TrusteeInformation.vue?vue&type=script&lang=js&"
export * from "./TrusteeInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/juhah/Documents/Projects/faa-generator/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib'
installComponents(component, {VTextField})
